import React from "react";
import axios from "axios";

export const uploadProfileImageApi = async (file, token) => {
  const form = new FormData();
  form.append("file", file);

    try {
      const options = {
        method: "PUT",
        url: "https://visapro-api.tcore.online/api/v1/users/upload-profile",
        headers: {
          'Authorization': `Basic ${token}` 
        },
        data: form,
      };
      const response = await axios.request(options)
      const fileUpload = {
        data: response.data.data,
      };
      return fileUpload;
    } catch (error) {
      const fileUpload = {
        error: error,
      };
      return fileUpload;
  }
};
